import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './MaleOrFemale.css';
const MaleOrFemale = ({ user }) => {
  const [selectedGender, setSelectedGender] = useState('');
  const [show, setShow] = useState(false);
  const [updating, setUpdating] = useState(false);

  // Définir les avatars pour chaque genre
  const avatars = {
    femme: 'upload/photos/f-avatar.jpg',
    homme: 'upload/photos/d-avatar.jpg',
  };

  useEffect(() => {
    // Afficher le sélecteur seulement si le genre est null
    if (user && user.gender === null) {
      setShow(true);
    }
  }, [user]);

  // Fonction pour gérer la sélection du genre
  const handleGenderSelect = (gender) => {
    setSelectedGender(gender);
  };

  // Fonction pour soumettre le formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedGender) {
      return;
    }
    
    setUpdating(true);
    
    try {
      // Créer l'objet de mise à jour
      const updateData = { gender: selectedGender };
      
      // Ne changer l'avatar que s'il s'agit de l'avatar par défaut
      if (!user.avatar || user.avatar === "no-gender-avatar.jpg") {
        updateData.avatar = avatars[selectedGender];
      }
      
      // Mettre à jour le profil utilisateur
      await sdk.models.PeupleUser.update(user.user_id, updateData);
      
      // Mettre à jour le localStorage si l'utilisateur est stocké
      const myself = localStorage.getItem("myself");
      if (myself) {
        const updatedUser = { ...JSON.parse(myself), gender: selectedGender };
        if (!user.avatar || user.avatar === "no-gender-avatar.jpg") {
          updatedUser.avatar = avatars[selectedGender];
        }
        localStorage.setItem("myself", JSON.stringify(updatedUser));
      }
      
      // Fermer le composant
      setShow(false);
    } catch (error) {
      console.error("Erreur lors de la mise à jour du genre:", error);
    } finally {
      setUpdating(false);
    }
  };

  if (!show) return null;

  return (
    <div className="mof-container">
      <div className="mof-header">
        <h3>Choisissez votre genre</h3>
        <p className="mof-description">Cette information nous aide à personnaliser votre expérience</p>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="mof-avatars">
          {Object.entries(avatars).map(([gender, src]) => (
            <div
              key={gender}
              className={`mof-avatar-option ${selectedGender === gender ? 'mof-selected' : ''}`}
              onClick={() => handleGenderSelect(gender)}
            >
              <div className="mof-avatar-container">
                <img 
                  src={`https://peupleqc.com/s/peupleqc-upload/${src}`} 
                  alt={`Avatar ${gender}`} 
                  className="mof-avatar-image" 
                />
                {selectedGender === gender && (
                  <div className="mof-check-mark">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <path fill="#ffffff" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                    </svg>
                  </div>
                )}
              </div>
              <p className="mof-gender-label">{gender === 'femme' ? 'Femme' : 'Homme'}</p>
            </div>
          ))}
        </div>
        
        <div className="mof-actions">
          <button 
            type="submit" 
            className="mof-submit-btn"
            disabled={!selectedGender || updating}
          >
            {updating ? 'Enregistrement...' : 'Continuer'}
          </button>
        </div>
      </form>
    </div>
  );
};

export { MaleOrFemale };